"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCorrelationIdLink = void 0;
const context_1 = require("@apollo/client/link/context");
const generate_correlation_id_1 = require("./utils/generate-correlation-id");
const createCorrelationIdLink = (correlationIdPreffix, uniqueIdGenerator) => (0, context_1.setContext)((_, { headers }) => ({
    headers: {
        ...headers,
        "x-correlation-id": (0, generate_correlation_id_1.generateCorrelationId)(correlationIdPreffix, uniqueIdGenerator),
    },
}));
exports.createCorrelationIdLink = createCorrelationIdLink;
//# sourceMappingURL=correlationIdLink.js.map